import IContact from "@/interfaces/contact.interface";
import { FilterType, IFilter } from "@/types/filter.types";

export const CONTACT_FILTERS_INITIAL_VALUE: IFilter<IContact>[] = [
  {
    property: "firstName",
    filterType: FilterType.Contains,
    value: "",
  },
];

export const CUSTOMER_ID_FILTER = (customerId: number): IFilter<IContact> => {
  const customerIdFilter: IFilter<IContact> = {
    property: "customerId",
    filterType: FilterType.Equals,
    value: customerId || 0,
  };

  return customerIdFilter;
};

export const ACTIVE_CONTACT_FILTER: IFilter<IContact> = {
  property: "active",
  filterType: FilterType.Equals,
  value: true,
};

export const initialFilterValues: IFilter<IContact>[] = [
  {
    property: "firstName",
    value: "",
    filterType: FilterType.Contains,
  },
  ACTIVE_CONTACT_FILTER,
];

export const pageNumber = 1;
export const pageSize = 1000;
